import Dataset from "datasets/types/interfaces/dataset";
import { resolveDatasetAccentColor } from "datasets/utils/color";
import { Folder } from "lucide-react";
import { cn } from "~/lib/utils";

interface DatasetIconProps {
  dataset?: Dataset;
  size?: number;
  className?: string;
  title?: string;
}

export const DatasetIcon = ({ dataset, size = 24, className, title }: DatasetIconProps) => {
  const folderSize = Math.round(size * 0.83);
  const accentColor = dataset ? resolveDatasetAccentColor(dataset.accentColor) : undefined;
  return (
    <div
      className={cn(
        "flex shrink-0 items-center justify-center",
        !dataset && "text-muted-foreground",
        className
      )}
      style={{ width: size, height: size }}
      title={title}
      aria-hidden={title ? undefined : true}
    >
      <Folder
        style={{ width: folderSize, height: folderSize }}
        color={accentColor?.fg ?? accentColor?.accent}
        fill={accentColor?.bg}
      />
    </div>
  );
};
